// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/Images/Content/Comparison/Content/Content/Actions/Choose/ImageSelect/Content/Content/Images/Content/PatientImage/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_Images_Content_Content_Content_Content_Images_Content_Comparison_Content_Content_Actions_Choose_ImageSelect_Content_Content_Images_Content_PatientImage($resource_id: StringOrNumber!) {
  vaxiom_resource_object_meta(resource_id: $resource_id, resource_type: image) {
    name
    content_type
    size
    url
    preview_url
  }
}

`